// src/api/EventApi.jsx
import api from './Restapi';

const eventApi = {
  getAll: async () => {
    const res = await api.get('/event');
    return res.data.map(event => ({
      ...event,
      eventDetails: event.event_details?.map(detail => ({
        ...detail,
        imageUrl: detail.image_url,
      })) || [],
    }));
  },

  getBySlug: async (slug) => {
    const res = await api.get(`/event/slug/${slug}`);
    const event = res.data;
    return {
      ...event,
      eventDetails: event.event_details?.map(detail => ({
        ...detail,
        imageUrl: detail.image_url,
      })) || [],
    };
  },

  create: async (payload) => {
    const res = await api.post('/event', payload);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await api.put(`/event/${id}`, payload);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/event/${id}`);
    return res.data;
  },
};

export default eventApi;
